import {
  TAB_LABEL_ACTIVITY_HISTORY,
  TAB_LABEL_CARE_PLAN_MILESTONE,
  TAB_LABEL_EDUCATION_CONTENT,
  TAB_LABEL_EDUCATION_LIBRARY,
  TAB_LABEL_IMAGE_THEME,
  TAB_LABEL_MANAGE_MILESTONES,
  TAB_LABEL_MANAGE_PATIENTS,
  TAB_LABEL_MANAGE_REDEMPTIONS,
  TAB_LABEL_MANAGE_USERS,
  TAB_LABEL_MILESTONE_DETAILS,
  TAB_LABEL_REPORTS,
  TAB_LABEL_ULTRASOUND_SCAN,
  ENGLISH_LANGUAGE_CODE,
  SPANISH_LANGUAGE_CODE,
} from "./locale";
import { StatusColor, LanguageCode } from "../interfaces/carePlanInterfaces";
import diamond from "../../assets/images/celebration-images/celeb_diamond_small.png";
import pearl from "../../assets/images/celebration-images/celeb_pearl.png";
import emerald from "../../assets/images/celebration-images/celeb_emerald.png";
import jade from "../../assets/images/celebration-images/celeb_jade.png";
import { FilterPayload } from "../interfaces/educationLibraryInterfaces";
import englishLogo from "../../assets/icons/english_logo.svg";
import spanishLogo from "../../assets/icons/spanish_logo.svg";

export const CONFIG = {
  baseURL: process.env.REACT_APP_BASE_URL,
  instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY,
};

export const ADMIN_CONFIGS = {
  CLIENT_ID: process.env.REACT_APP_ADMIN_CLIENT_ID,
  AUTHORITY: process.env.REACT_APP_ADMIN_AUTHORITY,
  REDIRECT_URI: process.env.REACT_APP_ADMIN_REDIRECT_URI,
  SCOPES: process.env.REACT_APP_ADMIN_SCOPES,
};

export const PATIENT_CONFIGS = {
  FHIR_CLIENT_ID: process.env.REACT_APP_FHIR_CLIENT_ID,
  REDIRECT_URI: process.env.REACT_APP_FHIR_REDIRECT_URI,
  LOCAL_STATE_KEY: process.env.REACT_APP_FHIR_LOCAL_STATE_KEY,
  MYCHART_LOGIN_REDIRECT_URL: process.env.REACT_APP_MYCHART_LOGIN_REDIRECT_URL,
};

export const MOMMY_MILESTONES = "Mommy-Milestones";
export const QUERY_SERVICE_BASE_URL =
  "https://dev-mommy-milestones.templehealth.org/backend";
// export const QUERY_SERVICE_BASE_URL = "https://ca-tuhs-mm-api-dev-eus-001.ashywater-9aa7012e.eastus.azurecontainerapps.io/";

export const MILESTONE_PLACEHOLDER =
  "Search by Milestone code, Milestone Name & Type";

export const MANAGE_ADMIN_PLACEHOLDER = "Search Name, User Status & Role";

// Milestone Progress Bar My reward activity link
export const TRACK_EVENT_INFO_MY_REWARD_ACTIVITY =
  "My Reward Activity button click";

// Tab objects
export const SUPER_ADMIN_DASHBOARD_TABS = [
  { value: TAB_LABEL_MANAGE_USERS, label: TAB_LABEL_MANAGE_USERS },
  { value: TAB_LABEL_MANAGE_PATIENTS, label: TAB_LABEL_MANAGE_PATIENTS },
  { value: TAB_LABEL_MANAGE_REDEMPTIONS, label: TAB_LABEL_MANAGE_REDEMPTIONS },
  { value: TAB_LABEL_MANAGE_MILESTONES, label: TAB_LABEL_MANAGE_MILESTONES },
  { value: TAB_LABEL_REPORTS, label: TAB_LABEL_REPORTS },
];

// Tab objects
export const ADMIN_DASHBOARD_TABS = [
  { value: TAB_LABEL_MANAGE_REDEMPTIONS, label: TAB_LABEL_MANAGE_REDEMPTIONS },
];

export const PATIENT_DASHBOARD_TABS = [
  {
    value: TAB_LABEL_CARE_PLAN_MILESTONE,
    label: TAB_LABEL_CARE_PLAN_MILESTONE,
  },
  { value: TAB_LABEL_EDUCATION_LIBRARY, label: TAB_LABEL_EDUCATION_LIBRARY },
  { value: TAB_LABEL_ULTRASOUND_SCAN, label: TAB_LABEL_ULTRASOUND_SCAN },
  { value: TAB_LABEL_IMAGE_THEME, label: TAB_LABEL_IMAGE_THEME },
];

export const EDIT_MILESTONE_TABS = [
  { value: TAB_LABEL_MILESTONE_DETAILS, label: TAB_LABEL_MILESTONE_DETAILS },
  { value: TAB_LABEL_EDUCATION_CONTENT, label: TAB_LABEL_EDUCATION_CONTENT },
  { value: TAB_LABEL_ACTIVITY_HISTORY, label: TAB_LABEL_ACTIVITY_HISTORY },
];

export const CREATE_MILESTONE_TABS = [
  { value: TAB_LABEL_MILESTONE_DETAILS, label: TAB_LABEL_MILESTONE_DETAILS },
  { value: TAB_LABEL_EDUCATION_CONTENT, label: TAB_LABEL_EDUCATION_CONTENT },
];

export const CONTENT_STATUS_COMPLETED_ID = 12; // Completed;
export const CONTENT_STATUS_PROGRESS_ID = 13; // Completed;

export const SAVE_CLICK_STATUS_ID = 0;
export const SAVE_ACCESSLOG_EDUCATION_COMPLETED = 2;

export const TIER_COLORS = [
  "#06A3B0",
  "#CF489A",
  "#A41E35",
  "#FDB913",
  "#FF6200",
];

export const TASK_MODE_RADIO_BTN_OPTIONS = [
  { label: "Single Code", value: false },
  { label: "Multi Code", value: true },
];

export const OPTIN_OUT_BUTTON = [
  { label: "OptIn", value: true },
  { label: "OptOut", value: false },
];

// Create an array of key-value pairs
export const ENGLISH_STATUS_COLORS: StatusColor[] = [
  { key: "In Progress", value: "rgba(255, 244, 226, 1)" },
  { key: "Completed", value: "rgba(227, 249, 231, 1)" },
  { key: "Not Completed", value: "rgba(255, 255, 255, 1)" },
  { key: "Task Pending", value: "rgba(255, 244, 226, 1)" },
  { key: "Pending", value: "rgba(255, 244, 226, 1)" },
];

export const SPANISH_STATUS_COLORS: StatusColor[] = [
  { key: "En progreso", value: "rgba(255, 244, 226, 1)" },
  { key: "Completado", value: "rgba(227, 249, 231, 1)" },
  { key: "No completado", value: "rgba(255, 255, 255, 1)" },
  { key: "Tarea Pendiente", value: "rgba(255, 244, 226, 1)" },
  { key: "Pendiente", value: "rgba(255, 244, 226, 1)" },
];

export const STATUS_COLORS: Record<LanguageCode, StatusColor[]> = {
  [ENGLISH_LANGUAGE_CODE]: ENGLISH_STATUS_COLORS,
  [SPANISH_LANGUAGE_CODE]: SPANISH_STATUS_COLORS,
};

export const ENGLISH_STATUS_BORDER_COLORS: StatusColor[] = [
  { key: "In Progress", value: "1px solid rgba(251, 176, 59, 1)" },
  { key: "Completed", value: "1px solid rgba(43, 169, 72, 1)" },
  { key: "Not Completed", value: "1px solid rgba(188, 166, 133, 1)" },
  { key: "Pending", value: "1px solid rgba(251, 176, 59, 1)" },
  { key: "Task Pending", value: "1px solid rgba(188, 166, 133, 1)" },
];

export const SPANISH_STATUS_BORDER_COLORS: StatusColor[] = [
  { key: "En progreso", value: "1px solid rgba(251, 176, 59, 1)" },
  { key: "Completado", value: "1px solid rgba(43, 169, 72, 1)" },
  { key: "No Completado", value: "1px solid rgba(188, 166, 133, 1)" },
  { key: "Pendiente", value: "1px solid rgba(251, 176, 59, 1)" },
  { key: "Tarea pendiente", value: "1px solid rgba(188, 166, 133, 1)" },
];

export const STATUS_BORDER_COLORS: Record<LanguageCode, StatusColor[]> = {
  [ENGLISH_LANGUAGE_CODE]: ENGLISH_STATUS_BORDER_COLORS,
  [SPANISH_LANGUAGE_CODE]: SPANISH_STATUS_BORDER_COLORS,
};

export const ACTIVITY_COMPLETION_STATUS = {
  COMPLETED: "Completed",
  NOT_COMPLETED: "Not Completed",
  TASK_PENDING: "Task Pending",
  PENDING: "Pending",
};

export const REGEX_VALIDATIONS = {
  SINGLE_CODE_REGEX: /^[a-zA-Z0-9]*$/,
  MULTI_CODE_REGEX: /^(?:[a-zA-Z0-9]*)(?:,[a-zA-Z0-9]*)*$/,
  URL_REGEX: /^(https?|chrome):\/\/[^\s$.?#].[^\s]*$/i,
};

export const PREGNANCY_WEEKS = [
  "6-8",
  "10-12",
  "16-18",
  "20",
  "24",
  "28",
  "32",
  "36",
  "37",
  "38",
  "39",
  "40",
];

export const MILESTONE_MESSAGES = {
  CreateMilestone: {
    carePlan: {
      Success: "Care Plan Milestone - Saved successfully",
      Fail: "Error - Care Plan Milestone - Not saved, try again",
    },
    education: {
      Success: "Education Milestone - Saved successfully",
      Fail: "Error - Education Milestone - Not saved, try again",
    },
  },
  EditMilestone: {
    carePlan: {
      Success: "Care Plan Milestone - Updated successfully",
      Fail: "Error - Care Plan Milestone - Not updated, try again",
    },
    education: {
      Success: "Education Milestone - Updated successfully",
      Fail: "Error - Education Milestone - Not updated, try again",
    },
  },
  SaveDraft: {
    carePlan: {
      Success: "Care Plan Milestone Draft - Saved successfully",
      Fail: "Error - Care Plan Milestone Draft - Not saved, try again",
    },
    education: {
      Success: "Education Milestone Draft - Saved successfully",
      Fail: "Error - Education Milestone Draft - Not saved, try again",
    },
  },
  Validation: {
    RequiredFields: "Please fill all required fields!",
    LinkNotVerified: "Please verify the link!",
    MultiCodeInvalid:
      "The code enter does not match, Please enter the code with comma separated",
  },
};

export const MESSAGE_IDS = {
  WELCOME_HEADING: "FirstBanner",
  WELCOME: "SecondBanner",
  TERMS_AND_CONDITIONS: "TermsAndConditions",
  OPT_OUT: "OptOutMessage",
  OPT_OUT_BANNER: "ContactAdmin",
  UNAUTHORIZED_ACCESS: "UserNotEligible",
  OPT_OUT_ERROR: "PostOptOutLoginError",
  JOURNEY_COMPLETED: "ProgramCompletedLoginError",
  AUTHORIZATION_ERROR: "AuthorizationError",
  TECH_ERROR: "TechError",
};

export const CelebrationCode = {
  PEARL: "PearlUnblocked",
  EMERALD: "EmeraldUnblocked",
  DIAMOND: "DiamondUnblocked",
  REWARD_CLAIMED: "RewardClaimed",
  FIRST_LOGIN: "FirstTimeLogin",
  BABY_BORN: "BabyBorn",
  FIRST_TRI_COMPLETED: "FirstTrimesterCompleted",
  SECOND_TRI_COMPLETED: "SecondTrimesterCompleted",
};

export const OPT_OUT_REASON_MSG_TYPE = "OptOutReason";
export const PATIENT_NO_SHOW_REASON_MSG_TYPE = "PatientMissingAppointment";

export const ADMIN_LIST_ERROR_MESSAGE = "Error Loading Admin List Data.";
export const EDIT_MANAGE_PATIENTS_MESSAGES = {
  editManagePatients: {
    Success: "Patient Detail - Updated successfully",
    Fail: "Error - Patient Detail - Not updated, try again",
    Warning: "Select Reason to update patients details",
    SameStatus: "Current status and target status cannot be the same.",
  },
};

export const TIER_CLASSIFICATION = {
  MOMMY_MEMBER: 1,
  TUMMY_TRAILBLAZERS: 2,
  GLOW_GETTERS: 3,
  BUMP_BOSSES: 4,
  FINAL_REWARDS: 5,
};
export const CATEGORY_ID_MAPPING = {
  adminProfile: 1,
  patientProfile: 2,
  displayGroup: 3,
  patientTask: 4,
  caseTask: 5,
  redemption: 6,
  episode: 10,
  patientLiving: 11,
  childLivingStatusAtBirth: 12,
  appointmentStatus: 13,
  orderStatus: 14,
  patientCase: 15,
  plans: 16,
  planTask: 17,
};

export const ADMINPROFILE_STATUS_ID_MAPPING = {
  active: 1,
  inactive: 2,
};
export const PATIENTPROFILE_STATUS_ID_MAPPING = {
  active: 3,
  inactive: 4,
};
export const DISPLAYGROUP_STATUS_ID_MAPPING = {
  notStarted: 5,
  inProgress: 6,
  completed: 7,
  taskPending: 8,
  initiated: 49,
};
export const PATIENTTASK_STATUS_ID_MAPPING = {
  draft: 9,
  active: 10,
  deactivated: 11,
};
export const CASETASK_STATUS_ID_MAPPING = {
  completed: 12,
  notCompleted: 13,
  pending: 14,
};
export const REDEMPTION_STATUS_ID_MAPPING = {
  notYetEligible: 15,
  eligible: 16,
  expired: 17,
  pending: 18,
  completed: 19,
};
export const EPISODE_STATUS_ID_MAPPING = {
  active: 20,
  resolved: 21,
};
export const PATIENTLIVING_STATUS_ID_MAPPING = {
  alive: 22,
  deceased: 23,
};
export const CHILDLIVINGSTATUSATBIRTH_STATUS_ID_MAPPING = {
  deceased: 24,
  neonatalDemise: 25,
  fetalDemise: 26,
  living: 63,
};
export const APPOINTMENTSTATUS_STATUS_ID_MAPPING = {
  scheduled: 27,
  completed: 28,
  canceled: 29,
  noShow: 30,
  leftWithoutSeen: 31,
  arrived: 32,
};
export const ORDERSTATUS_STATUS_ID_MAPPING = {
  pending: 33,
  sent: 34,
  resulted: 35,
  canceled: 36,
  completed: 37,
  holdingForReferral: 38,
  deniedApproval: 39,
  suspend: 40,
  discontinued: 41,
  verified: 42,
  dispensed: 43,
  pendingVerify: 44,
};
export const PATIENTCASE_STATUS_ID_MAPPING = {
  enrollmentPending: 45,
  active: 46,
  inactive: 47,
  journeyCompleted: 48,
  optout: 53,
};
export const PLANS_STATUS_ID_MAPPING = {
  active: 50,
};
export const PLANTASK_STATUS_ID_MAPPING = {
  active: 51,
  inactive: 52,
};

// Multi Language constants
export const LANGUAGE_NAME_ENGLISH = "english";

// Baby image theme constants
export const IMAGE_THEME = "ImageTheme";
export const SELECT_THEME_LABEL = "Select Theme";

export const NEW_PATIENT_DASHBOARD_TABS = [
  {
    appModuleId: 1,
    moduleName: "My Dashboard",
    iconName: "dashboard",
    isActive: false,
    appModuleCode: "module001",
    displaySequence: 1,
    toolTipText: null,
  },
  {
    appModuleId: 2,
    moduleName: "My Care Plan",
    iconName: "carePlan",
    isActive: false,
    appModuleCode: "module002",
    displaySequence: 2,
    toolTipText: null,
  },
  {
    appModuleId: 3,
    moduleName: "My Ultrasound",
    iconName: "ultrasound",
    isActive: false,
    appModuleCode: "module003",
    displaySequence: 3,
    toolTipText:
      "Any available ultrasounds provided by Temple will be shown here",
  },
  {
    appModuleId: 4,
    moduleName: "My Rewards",
    iconName: "rewards",
    isActive: false,
    appModuleCode: "module004",
    displaySequence: 4,
    toolTipText: null,
  },
  {
    appModuleId: 5,
    moduleName: "My Learning",
    iconName: "learning",
    isActive: false,
    appModuleCode: "module005",
    displaySequence: 5,
    toolTipText: null,
  },
];

// Color constants
export const TEXT_COLOR_BLACK = "#1A1A1A";
export const PRIMARY_GREEN = "#4E7E6E";
export const GREEN_LIGHT = "#BCD0BF";
export const GREY = "#D1D1D1";
export const GREY_DARK = "#666666";
export const WHITE = "#ffffff";
export const BLACK = "#000000";
export const SKY_BLUE = "#EAF0F0";
export const PEACH = "#FFE9D9";

export const CARE_PLAN_FILTERS = [
  { labelKey: "carePlan.filters.all", value: "All" },
  { labelKey: "carePlan.filters.firstTrimester", value: 1 },
  { labelKey: "carePlan.filters.secondTrimester", value: 2 },
  { labelKey: "carePlan.filters.thirdTrimester", value: 3 },
  { labelKey: "carePlan.filters.postpartum", value: 4 },
];

export const DEFAULT_TIER = 1;

// Widget keys
export type WidgetKey = "spotlightSection" | "babySection" | "carePlan" | "myRewards" | "myLearning";

// Default widget order
export const DEFALUT_WIDGET_ORDER: WidgetKey[] = [
  "babySection",
  "carePlan",
  "myLearning",
  "myRewards",
];

// Mapping appModuleId (from API) to widget keys
export const APP_MODULE_ID_TO_KEY: Record<number, WidgetKey> = {
  0: "spotlightSection",
  1: "babySection",
  2: "carePlan",
  3: "myLearning",
  4: "myRewards",
};

export const TIER_IMG_MAP: Record<string, string> = {
  1: jade,
  2: pearl,
  3: emerald,
  4: diamond,
};
export const DEFAULT_LEARNING_FILTERS: FilterPayload = {
  rewardsEligibility: false,
  hideCompleted: false,
  contentType: [],
  trimester: [],
  category: [],
};

export const FilterApiData = {
  SELECT_ALL: "Select All",
  FILTER_CATEGORY_GENERAL: "General",
  FILTER_POINTS_ELIGIBLE: "Points Eligible",
  FILTER_HIDE_COMPLETED: "Hide Completed",
  FILTER_PHASE: "Phase",
  FILTER_TYPE: "Type",
  FILTER_CATEGORY: "Category",
  FILTER_POST_CONTENT_TYPE: "contentType",
  FILTER_POST_TRIMESTER: "trimester",
  FILTER_POST_CATEGORY: "category",
};

export const FAQ_FILTER = "ApplicationFAQ";

export const API_ERROR_STATUS_CODE = {
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  ERROR_BREAKPOINT: 402,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
};

export const EDUCATION_CONTENT_SORCE_ID = {
  AGILITY_CMS_ID: 3,
};

export const LANGUAGE_ICONS: Record<string, string> = {
  English: englishLogo,
  Spanish: spanishLogo,
};
